import { compose } from 'redux'
import withSessionLogic from './withSessionLogic'
import withRedux from './withRedux'
import withEventHandlers from './withEventHandlers'
import UI from './UI'

export default compose(
  withRedux,
  withSessionLogic,
  withEventHandlers
)(UI)
